import { Box, Stack, Typography } from '@mui/material';
import { IconTile } from 'src/components/IconTile';
import { PageHeaderProps } from './page-header.types';

/**
 * Every page opens with the same title/subtitle/actions block. Factoring it out
 * keeps that typography and spacing identical across pages (one place to change
 * the design) instead of each page hand-rolling its own header markup.
 *
 * Page title block: optional leading icon + title + optional subtitle, with
 * optional right-aligned actions.
 */
export const PageHeader = ({
  title,
  subtitle,
  startAdornment,
  icon,
  actions,
}: PageHeaderProps) => (
  <Stack
    direction="row"
    alignItems="flex-start"
    justifyContent="space-between"
    spacing={2}
    sx={{ pt: 4, pb: 2 }}
  >
    <Box>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        {startAdornment}
        {icon ? <IconTile>{icon}</IconTile> : null}
        {/* TODO: change variant to h1 in the next PRs */}
        <Typography variant="h5" fontWeight={600} color="custom.OV.sys.onSurface">
          {title}
        </Typography>
      </Stack>
      {subtitle ? (
        <Typography variant="body2" color="custom.OV.sys.onSurfaceVariant" sx={{ mt: 1 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
    {actions ? <Box sx={{ flexShrink: 0 }}>{actions}</Box> : null}
  </Stack>
);

PageHeader.displayName = 'PageHeader';
